import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { services } from '../data/site';
import { Reveal } from './Reveal';
export function Services() {
  return <section id="services" className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-32" data-id="element-138" data-mp="1dt9ek0npvuzh">
      <Reveal data-id="element-139" data-mp="18vhbqbljaogi">
        <div className="flex flex-col gap-6 border-b border-line pb-10 sm:flex-row sm:items-end sm:justify-between" data-id="element-140" data-mp="18twfmhjkmxgj">
          <div data-id="element-141" data-mp="13xfrvogaal3z">
            <p className="text-[11px] uppercase tracking-label text-graphite" data-id="element-142" data-mp="13x63g5aw0m0e">Services</p>
            <h2 className="mt-5 max-w-2xl font-display text-4xl leading-[1.05] tracking-tight lg:text-5xl" data-id="element-143" data-mp="z3l8km4lc85f">
              Je vous accompagne dans tous types de projets
            </h2>
          </div>
          <Link to="/services" className="group inline-flex shrink-0 items-center gap-3 text-[11px] uppercase tracking-label" data-id="element-144" data-mp="q6b018j5qx47">
            Détail des prestations
            <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-145" data-mp="g6sfapvfb7b3" />
          </Link>
        </div>
      </Reveal>

      <ul data-id="element-146" data-mp="3b4r7thy1m7ys">
        {services.map((service, index) => <Reveal key={service.title} delay={0.04 * index} data-id="element-147" data-mp="2xcb6qmopck0i" data-mpi={index}>
            <li data-id="element-148" data-mp="2x9yi5qofvbeh">
              <Link to="/services" className="group grid gap-3 border-b border-line py-8 transition-colors duration-150 ease-smooth hover:bg-chalk lg:grid-cols-12 lg:items-baseline lg:gap-8" data-id="element-149" data-mp="32aw1i6l6qbhk">
                <p className="text-[11px] uppercase tracking-label text-graphite lg:col-span-2" data-id="element-150" data-mp="3u0r06tuxndiw">{service.meta}</p>
                <h3 className="font-display text-2xl leading-tight transition-colors duration-150 ease-smooth group-hover:text-clay lg:col-span-5 lg:text-3xl" data-id="element-151" data-mp="3g1radivoosl5">
                  {service.title}
                </h3>
                <p className="text-[15px] leading-relaxed text-graphite lg:col-span-5" data-id="element-152" data-mp="24p70kedvhzn5">{service.text}</p>
              </Link>
            </li>
          </Reveal>)}
      </ul>
    </section>;
}